import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModuleProgressDetailPageRoutingModule } from './module-progress-detail-routing.module';

import { ModuleProgressDetailPage } from './module-progress-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleProgressDetailPageRoutingModule
  ],
  declarations: [ModuleProgressDetailPage]
})
export class ModuleProgressDetailPageModule {}
